'use client';

import React__default, { useState, useCallback } from 'react';
import { t } from '../Utils/helpers.js';
import s from './CheckBoxTextarea.module.scss.js';

var LimitedTextarea = function (props) {
    // TODO create component with limit
    var inputText = props.inputText, _a = props.placeholder, placeholder = _a === void 0 ? '' : _a;
    var _b = useState(props.value.slice(0, props.limit)), content = _b[0], setContent = _b[1];
    var isMaxContent = content.length > props.limit;
    var setFormattedContent = useCallback(function (text) {
        setContent(text);
    }, [setContent]);
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("textarea", { className: s.textArea, rows: 4, onChange: function (e) {
                setFormattedContent(e.target.value);
                inputText && inputText(e.target.value);
            }, value: content, placeholder: placeholder }),
        React__default.createElement("div", { style: { fontSize: 12, color: isMaxContent ? '#f85a5a' : '#6c757d', marginTop: 6 } }, "".concat(content.length, "/").concat(props.limit)),
        isMaxContent && (React__default.createElement("div", { style: { fontSize: 12, color: '#f85a5a', marginTop: 4 } }, "".concat(t('Exceeded maximum character length of', props.language || 'vi'), " ").concat(props.limit)))));
};

export { LimitedTextarea as default };
//# sourceMappingURL=index.js.map
